module.exports = __webpack_public_path__ + "static/media/hdfc_insurance_small_logo.2a1f894c.png";